module.exports = __webpack_public_path__ + "img/pr-7.2131c7a2.png";